import { useState, useEffect } from 'react';
import Navbar from '../home_page/navbar';
import Footer from '../home_page/footer';
import './internship_form.css';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { constants } from '../../constants';
import { showToast } from './toast'; // NEW: toast notifications

function InternshipForm() {
  const location = useLocation();
  const navigate = useNavigate();

  const appliedFor = location.state?.appliedFor || '';

  useEffect(() => {
    if (!appliedFor) {
      // Redirect to /exclusive if appliedFor is empty
      navigate('/exclusive', { replace: true });
    }
  }, [appliedFor, navigate]);

  const [emailAdd, setEmailAdd] = useState('');
  const [phoneNum, setPhoneNum] = useState('');
  const [name, setName] = useState('');
  const [gender, setGender] = useState('');
  const [error, setError] = useState('');
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [dateError, setDateError] = useState('');
  const [date, setDate] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [nameError, setNameError] = useState('');
  const [genderError, setGenderError] = useState('');

  // OTP
  // OTP Verification
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState('');
  const [otpMessage, setOtpMessage] = useState('');

  // Academic
  const [schoolName, setSchoolName] = useState('');
  const [schoolType, setSchoolType] = useState('');
  const [currentClass, setCurrentClass] = useState('');
  const [board, setBoard] = useState('');

  // File uploads
  const [motivationFile, setMotivationFile] = useState(null);
  const [resumeFile, setResumeFile] = useState(null);
  const [passportCopy, setPassportCopy] = useState(null);
  const [passportPhoto, setPassportPhoto] = useState(null);
  const [studentIdPhoto, setStudentIdPhoto] = useState(null);
  const [paymentPhoto, setPaymentPhoto] = useState('');
  const [whySelected, setWhySelected] = useState('');

  const [schoolNameError, setSchoolNameError] = useState('');
  const [schoolTypeError, setSchoolTypeError] = useState('');
  const [currentClassError, setCurrentClassError] = useState('');
  const [boardError, setBoardError] = useState('');

  const [motivationFileError, setMotivationFileError] = useState('');
  const [resumeFileError, setResumeFileError] = useState('');
  const [passportCopyError, setPassportCopyError] = useState('');
  const [passportPhotoError, setPassportPhotoError] = useState('');
  const [studentIdPhotoError, setStudentIdPhotoError] = useState('');
  const [paymentPhotoError, setPaymentPhotoError] = useState('');
  const [whySelectedError, setWhySelectedError] = useState('');

  //checkbox
  const [ageConsent, setAgeConsent] = useState(false);
  const [phase1, setPhase1] = useState(false);
  const [nonRefundable, setNonRefundable] = useState(false);
  const [checkboxError, setCheckboxError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const today = new Date();
  today.setFullYear(today.getFullYear() - 13); // subtract 12 years
  const maxAllowedDate = today.toISOString().split('T')[0];
  // Email Verification OTP sending
  const handleEmailVerify = async (e) => {
    e.preventDefault();
    let isValid = true;
    if (emailAdd.trim() === '') {
      setEmailError('Email cannot be empty');
      return;
    }

    try {
      const requestOtpUrl = `${constants.baseUrl}/api/auth/request-otp`;
      const response = await axios.post(
        requestOtpUrl,
        {
          otpFor: 'internship', // REQUIRED CHANGE
          email: emailAdd,
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      console.log(response.data);
      if (response.data.message === 'OTP sent to your email') {
        setShowOtpInput(true);
        console.log(showOtpInput);
        console.log('Console');
        setEmailError('');
        setOtpMessage('OTP sent to your email.');
      } else {
        setEmailError(response.data.message || 'Failed to send OTP');
      }
    } catch (error) {
      console.error(error);
      setEmailError(error.response?.data?.message || 'Failed to send OTP. Try again.');
    }
    setError('');
    if (!isValid) return;
  };
  const handleOtpVerify = async () => {
    if (!otp.trim() || otp.length !== 6) {
      // alert('Please enter the OTP');
      showToast('Please enter full 6 numbered OTP', 'error');
      return;
    }
    try {
      const response = await axios.post(
        `${constants.baseUrl}/api/auth/verify-otp`,
        {
          email: emailAdd,
          otp: otp,
        },
        { headers: { 'Content-Type': 'application/json' } }
      );
      if (response.data.message === 'OTP verified successfully') {
        setIsOtpVerified(true);
        setOtpMessage('OTP Verified Successfully!');
      } else {
        // alert(response.data.message || 'Invalid OTP');
        showToast(response.data.message || 'Invalid OTP', 'error');
      }
    } catch (error) {
      console.error('OTP verification failed:', error);
      // alert(error.response?.data?.message || 'OTP verification failed. Please try again.');
      showToast(
        error.response?.data?.message || 'OTP verification failed. Please try again.',
        'error'
      );
    }
  };

  const handleSubmit = async (e) => {
    console.log('function working');
    //prevents the form from -
    //reloading the page
    //resetting the states
    //sending the data to the server
    e.preventDefault();
    if (isSubmitting) return;

    let isValid = true;

    // Clear previous errors first
    setEmailError('');
    setPhoneError('');
    setNameError('');
    setGenderError('');
    setDateError('');
    setSchoolNameError('');
    setSchoolTypeError('');
    setCurrentClassError('');
    setBoardError('');
    setMotivationFileError('');
    setResumeFileError('');
    setPassportCopyError('');
    setPassportPhotoError('');
    setStudentIdPhotoError('');
    setWhySelectedError('');
    setPaymentPhotoError('');

    // Email validation regex
    const emailAddRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    //Phone Validation Regex
    const phoneNumRegex = /^[6-9]\d{9}$/;

    // email error logic
    if (!emailAddRegex.test(emailAdd)) {
      setEmailError('Please enter a valid email address.');
      isValid = false;
    }
    if (!phoneNumRegex.test(phoneNum)) {
      setPhoneError('Please enter a valid phone number');
      isValid = false;
    }
    if (date.trim() === '') {
      setDateError('Date cannot be empty');
      isValid = false;
    }
    if (name.trim() === '') {
      setNameError('Name cannot be empty');
      isValid = false;
    }
    if (gender.trim() === '') {
      setGenderError('Gender cannot be empty');
      isValid = false;
    }
    if (whySelected.trim() === '') {
      setWhySelectedError('Text Area cannot be empty');
      isValid = false;
    }

    // Academic/Professional Validation
    if (!schoolName.trim()) {
      setSchoolNameError('School Name cannot be empty.');
      isValid = false;
    }
    if (!schoolType.trim()) {
      setSchoolTypeError('School Type cannot be empty.');
      isValid = false;
    }
    if (!currentClass.trim()) {
      setCurrentClassError('Class/Grade cannot be empty.');
      isValid = false;
    }
    if (!board.trim()) {
      setBoardError('Board cannot be empty.');
      isValid = false;
    }

    // File Upload Validation
    if (!motivationFile) {
      setMotivationFileError('Letter of Motivation is required.');
      isValid = false;
    }
    if (!resumeFile) {
      setResumeFileError('Resume is required.');
      isValid = false;
    }
    if (!passportCopy) {
      setPassportCopyError('Passport Copy is required.');
      isValid = false;
    }
    if (!passportPhoto) {
      setPassportPhotoError('Passport Sized Photo is required.');
      isValid = false;
    }
    if (!studentIdPhoto) {
      setStudentIdPhotoError('Student ID Photo is required.');
      isValid = false;
    }
    if (!paymentPhoto) {
      setPaymentPhotoError('Payment Photo is required.');
      isValid = false;
    }

    setCheckboxError('');
    if (!ageConsent || !phase1 || !nonRefundable) {
      setCheckboxError('You must agree to all the terms before submitting.');
      isValid = false;
    }
    if (new Date(date) > new Date(maxAllowedDate)) {
      setDateError('You must be at least 10 years old to apply.');
      isValid = false;
    }

    setError('');
    if (!isValid) return;

    setIsSubmitting(true);

    const data = new FormData();
    data.append('appliedFor', appliedFor);
    data.append('fullName', name);
    data.append('dateOfBirth', date);
    data.append('gender', gender);
    data.append('email', emailAdd);
    data.append('mobileNumber', phoneNum);
    data.append('schoolName', schoolName);
    data.append('schoolType', schoolType);
    data.append('currentClass', currentClass);
    data.append('board', board);
    data.append('letterOfMotivation', motivationFile);
    data.append('whySelected', whySelected);
    data.append('cv', resumeFile);
    data.append('passportCopy', passportCopy);
    data.append('passportPhoto', passportPhoto);
    data.append('studentIdPhoto', studentIdPhoto);
    data.append('paymentReceipt', paymentPhoto);
    data.append('over16', ageConsent);
    data.append('understandsCompetitive', phase1);
    data.append('acceptsFee', nonRefundable);
    try {
      const response = await axios.post(`${constants.baseUrl}/api/forms/internship`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      // console.log('Response:', response.data);

      if (response.data.message === 'Form submission received') {
        // window.location.reload();
        // alert('Internship form submitted successfully!');
        showToast('Internship form submitted successfully!', 'success');
        setTimeout(() => window.location.reload(), 4000);
      } else {
        // alert(response.data.message || 'Submission failed');
        showToast(response.data.message || 'Submission failed', 'error');
      }
    } catch (err) {
      console.error('Error submitting form:', err);
      // alert(err.response?.data?.message || 'Submission failed. Try again.');
      setIsSubmitting(false);
      showToast(err.response?.data?.message || 'Submission failed. Try again.', 'error');
    }

    // const jsonPreview = {};

    // for (let [key, value] of data.entries()) {
    //   console.log(key, value);
    // }

    // console.log(JSON.stringify(jsonPreview, null, 2));

    // 3️⃣ RELOAD ENTIRE PAGE (optional, if you want a clean reset)

    // try {
    //     const response = await fetch("localhost:3000", {
    //         method: "POST",
    //         body: data
    //     });

    //     const result = await response.json();
    //     console.log("Server response:", result);
    //     }
    // catch (err) {
    //     console.error("Error submitting form:", err);
    // }
  };
  return (
    <div>
      <Navbar />
      <div class="form-page">
        {/* Form */}
        <div id="form">
          <form>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <div className="form-col">
              <div className="form-section form-title-container">
                <p className="form-section-title">Personal Details</p>
                <a
                  href="https://docs.google.com/document/d/1Jp1I5KD3nnxuNz0A7sqi3vnrlayH0ksLHeydYtvx04A/edit?usp=sharing"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="personal-details-link"
                  style={{ marginBottom: '10px' }}
                >
                  Internship Details and Instructions on How to fill the form
                </a>
              </div>
              <div className="form-col">
                <label>Email Address</label>
                <div className="form-row request-otp-row">
                  <input
                    type="text"
                    style={{
                      width: '75%',
                      padding: '8px',
                      marginTop: '4px',
                    }}
                    disabled={isOtpVerified}
                    value={emailAdd}
                    onChange={(e) => setEmailAdd(e.target.value)}
                    placeholder="Enter your Email"
                  />
                  <button type="button" className="request-otp" onClick={handleEmailVerify}>
                    Request OTP
                  </button>
                </div>
                <div className="form-col">
                  {otpMessage && <p style={{ color: 'green', marginTop: '5px' }}>{otpMessage}</p>}
                  <div className="form-row verify-otp-row">
                    {showOtpInput && !isOtpVerified && (
                      <div className="form-col">
                        <label>Enter OTP</label>
                        <div className="form-row verify-otp" style={{ marginTop: '10px' }}>
                          <input
                            type="text"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            placeholder="Enter the OTP sent to your email"
                            className="verify-otp-input"
                          />
                          <button
                            type="button"
                            className="verify-otp-button"
                            onClick={handleOtpVerify}
                          >
                            Verify OTP
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  {emailError && <p style={{ color: 'red' }}>{emailError}</p>}
                </div>
              </div>
              <div className="form-row">
                <div className="form-col">
                  <label>Full Name</label>
                  <input
                    type="text"
                    value={name}
                    style={{
                      width: '100%',
                      padding: '8px',
                      marginTop: '4px',
                    }}
                    disabled={!isOtpVerified}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter your name"
                  />
                  {nameError && <p style={{ color: 'red' }}>{nameError}</p>}
                </div>
                <div className="form-col">
                  <label>Date of Birth</label>
                  <input
                    type="date"
                    max={maxAllowedDate}
                    style={{
                      width: '100%',
                      padding: '8px',
                      marginTop: '4px',
                    }}
                    disabled={!isOtpVerified}
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    placeholder="D.O.B"
                  />
                  {dateError && <p style={{ color: 'red' }}>{dateError}</p>}
                </div>
              </div>
              <div className="form-row">
                <div className="form-col">
                  <label>Gender</label>
                  <select
                    value={gender}
                    disabled={!isOtpVerified}
                    onChange={(e) => setGender(e.target.value)}
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                  {/* <input
                    type="text"
                    style={{
                      width: '100%',
                      padding: '8px',
                      marginTop: '4px',
                    }}
                    value={gender}
                    disabled={!isOtpVerified}
                    onChange={(e) => setGender(e.target.value)}
                    placeholder="Gender"
                  /> */}
                  {genderError && <p style={{ color: 'red' }}>{genderError}</p>}
                </div>
                <div className="form-col">
                  <label>Phone Number</label>
                  <input
                    type="number"
                    min="5000000000"
                    max="10000000000"
                    style={{
                      width: '100%',
                      padding: '8px',
                      marginTop: '4px',
                    }}
                    value={phoneNum}
                    disabled={!isOtpVerified}
                    onChange={(e) => setPhoneNum(e.target.value)}
                    placeholder="Enter your Mobile Number"
                  />
                  {phoneError && <p style={{ color: 'red' }}>{phoneError}</p>}
                </div>
              </div>
              {/* Academic */}
              <div className="form-col">
                <div className="form-section form-title-container">
                  <p className="form-section-title">Academic/Professional Details</p>
                </div>
                <div className="form-row">
                  <div className="form-col">
                    <label>School Name</label>
                    <input
                      type="text"
                      style={{
                        width: '100%',
                        padding: '8px',
                        marginTop: '4px',
                      }}
                      value={schoolName}
                      disabled={!isOtpVerified}
                      onChange={(e) => setSchoolName(e.target.value)}
                      placeholder="School Name"
                    />
                    {schoolNameError && (
                      <p style={{ color: 'red' }} className="form-warning">
                        {schoolNameError}
                      </p>
                    )}
                  </div>
                  <div className="form-col">
                    <label>School Type</label>
                    <select
                      value={schoolType}
                      disabled={!isOtpVerified}
                      onChange={(e) => setSchoolType(e.target.value)}
                    >
                      <option value="">Select School Type</option>
                      <option value="Government">Government</option>
                      <option value="Private">Private/General</option>
                    </select>
                    {schoolTypeError && (
                      <p style={{ color: 'red' }} className="form-warning">
                        {schoolTypeError}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="form-col">
                  <label>Current Class/Grade</label>
                  <input
                    type="number"
                    min="9"
                    max="12"
                    style={{
                      width: '100%',
                      padding: '8px',
                      marginTop: '4px',
                    }}
                    placeholder="Class"
                    value={currentClass}
                    disabled={!isOtpVerified}
                    onChange={(e) => setCurrentClass(e.target.value)}
                  />
                  {currentClassError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {currentClassError}
                    </p>
                  )}
                </div>
                <div className="form-col">
                  <label>Board</label>
                  <input
                    type="text"
                    style={{
                      width: '100%',
                      padding: '8px',
                      marginTop: '4px',
                    }}
                    value={board}
                    onChange={(e) => setBoard(e.target.value)}
                    placeholder="CBSE/ICSE etc."
                  />
                  {boardError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {boardError}
                    </p>
                  )}
                </div>
              </div>
              {/* Folder Upload */}
              <div className="form-col">
                <div className="form-section form-title-container">
                  <p className="form-section-title">Documents Required</p>
                </div>
                <div className="form-row">
                  <div className="form-col">
                    <label for="motivate">Letter of Motivation:</label>
                    <input
                      type="file"
                      accept=".txt, .pdf, .docx, .rtf"
                      onChange={(e) => setMotivationFile(e.target.files[0])}
                      className="file-input"
                      name="motivate"
                      disabled={!isOtpVerified}
                    ></input>
                    {motivationFileError && (
                      <p style={{ color: 'red' }} className="form-warning">
                        {motivationFileError}
                      </p>
                    )}
                  </div>
                  <div className="form-col">
                    <label for="resume">Resume</label>
                    <input
                      type="file"
                      accept=".txt, .pdf, .docx, .rtf"
                      onChange={(e) => setResumeFile(e.target.files[0])}
                      class="file-input"
                      name="resume"
                      disabled={!isOtpVerified}
                    ></input>
                    {resumeFileError && (
                      <p style={{ color: 'red' }} className="form-warning">
                        {resumeFileError}
                      </p>
                    )}
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-col">
                    <label for="passportcopy">Passport Copy</label>
                    <input
                      type="file"
                      accept="image/*, .pdf"
                      class="file-input"
                      name="passportcopy"
                      onChange={(e) => setPassportCopy(e.target.files[0])}
                      disabled={!isOtpVerified}
                    ></input>
                    {passportCopyError && (
                      <p style={{ color: 'red' }} className="form-warning">
                        {passportCopyError}
                      </p>
                    )}
                  </div>
                  <div className="form-col">
                    <label for="passportphoto">Passport Sized Photo</label>
                    <input
                      type="file"
                      accept="image/*, .pdf"
                      class="file-input"
                      name="passportphoto"
                      onChange={(e) => setPassportPhoto(e.target.files[0])}
                      disabled={!isOtpVerified}
                    ></input>
                    {passportPhotoError && (
                      <p style={{ color: 'red' }} className="form-warning">
                        {passportPhotoError}
                      </p>
                    )}
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-col">
                    <label for="idphoto">Student Id Photo</label>
                    <input
                      type="file"
                      accept="image/*, .pdf"
                      class="file-input"
                      name="idphoto"
                      onChange={(e) => setStudentIdPhoto(e.target.files[0])}
                      disabled={!isOtpVerified}
                    ></input>
                    {studentIdPhotoError && (
                      <p style={{ color: 'red' }} className="form-warning">
                        {studentIdPhotoError}
                      </p>
                    )}
                  </div>
                  <div className="form-col">
                    <label for="mypayment">Payment Verification</label>
                    <input
                      type="file"
                      accept="image/*, .pdf"
                      class="file-input"
                      name="mypayment"
                      onChange={(e) => setPaymentPhoto(e.target.files[0])}
                      disabled={!isOtpVerified}
                    ></input>
                    {paymentPhotoError && (
                      <p style={{ color: 'red' }} className="form-warning">
                        {paymentPhotoError}
                      </p>
                    )}
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-col">
                    <label className="form-section-title">Why should You be selected</label>
                    <textarea
                      style={{
                        padding: '8px',
                        marginTop: '4px',
                      }}
                      rows="8"
                      placeholder="Type your message"
                      value={whySelected}
                      onChange={(e) => setWhySelected(e.target.value)}
                      disabled={!isOtpVerified}
                    ></textarea>
                    {whySelectedError && (
                      <p style={{ color: 'red' }} className="form-warning">
                        {whySelectedError}
                      </p>
                    )}
                  </div>
                </div>
                <div className="form-col checkbox-section">
                  <div className="form-row form-checkbox">
                    <input
                      type="checkbox"
                      id="age-consent"
                      name="age-consent"
                      checked={ageConsent}
                      onChange={(e) => setAgeConsent(e.target.checked)}
                      disabled={!isOtpVerified}
                    ></input>
                    <label for="age-consent"> I confirm that I am over 14 years old </label>
                  </div>
                  <div className="form-row form-checkbox">
                    <input
                      type="checkbox"
                      id="phase-1"
                      name="phase-1"
                      checked={phase1}
                      onChange={(e) => setPhase1(e.target.checked)}
                      disabled={!isOtpVerified}
                    ></input>
                    <label for="phase-1">
                      {' '}
                      I understand this form is Phase-I, and selection is competitive{' '}
                    </label>
                  </div>
                  <div className="form-row form-checkbox">
                    <input
                      type="checkbox"
                      id="non-refundable"
                      name="non-refundable"
                      checked={nonRefundable}
                      onChange={(e) => setNonRefundable(e.target.checked)}
                      disabled={!isOtpVerified}
                    ></input>
                    <label for="non-refundable">
                      {' '}
                      I accept the non-refundable application fee{' '}
                    </label>
                  </div>
                  {checkboxError && (
                    <p style={{ color: 'red' }} className="form-warning">
                      {checkboxError}
                    </p>
                  )}
                </div>

                <div className="form-row">
                  <div className="form-col submit-button-col">
                    <button
                      className="form-submit-button"
                      type="submit"
                      onClick={handleSubmit}
                      disabled={isSubmitting}
                      style={{
                        opacity: isSubmitting ? 0.6 : 1,
                        cursor: isSubmitting ? 'not-allowed' : 'pointer',
                      }}
                    >
                      {isSubmitting ? 'Submitting...' : 'Submit'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default InternshipForm;
